module.exports = __webpack_public_path__ + "img/组 40@2x (3).a71cb11c.png";